module.exports = __webpack_public_path__ + "static/pinkbunny4-732620fdcef5d2a225c708ab12aeee41.png";